var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("销售价:"+_vm._s(_vm.storePrice2.storeSquarePrice))]),_vm._v(" "),_c('p',[_vm._v("活动价:"+_vm._s(_vm.storePrice2.storeActivitySquarePrice))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b727184","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/dealer/store/store-priceVo2.vue
// module id = null
// module chunks = 